/* global axios */
import ApiClient from '../ApiClient';

class WgptBotWorkflowsAPI extends ApiClient {
  constructor(botId) {
    super(`bots/${botId}/workflows`, { accountScoped: true, wgpt: true });
  }

  getLlmConfigs() {
    return axios.get(`${this.url}/llm_configs`);
  }
}

export default WgptBotWorkflowsAPI;
